import { FuseAuthorization, FuseLayout, FuseTheme } from '@fuse';
import { createGenerateClassName, jssPreset } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import { create } from 'jss';
import jssExtend from 'jss-extend';
import React from 'react';
import CookieConsent from "react-cookie-consent";
import JssProvider from 'react-jss/lib/JssProvider';
import Provider from 'react-redux/es/components/Provider';
import { Router } from 'react-router-dom';
import history from '../history';
import AppContext from './AppContext';
import routes from './Configs/fuse-configs/routesConfig';
import ScreenLockApp from './Core/Components/ScreenLock/ScreenLockApp';
import { Auth } from './Core/Funcionalidade/Auth';
import store from './store';

const jss = create({
    ...jssPreset(),
    plugins: [...jssPreset().plugins, jssExtend()]
});

jss.options.insertionPoint = document.getElementById('jss-insertion-point');
const generateClassName = createGenerateClassName();

class App extends XAPPComponent {

    state = {
        showInstallMessage: false
    }

    componentDidMount() {
        this.setConfigByHost();
    }

    componentDidUpdate() {
        const { showInstallMessage } = this.state;
        if (this.isIos() && !this.isInStandaloneMode() && !showInstallMessage) {
            this.setState({ showInstallMessage: true });
        }
    }

    setConfigByHost = () => {
        const { hostname } = document.location;
        const hostPartial = document.location.hostname.replace(".com.br", "");
        document.title = hostPartial.split(".")[hostPartial.split(".").length - 1].toUpperCase();

    }

    isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    }

    isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

    render() {
        const { hostname } = document.location;
        return (
            <AppContext.Provider
                value={{ routes }}
            >
                <JssProvider jss={jss} generateClassName={generateClassName}>
                    <Provider store={store}>
                        <Auth>
                            <Router history={history}>
                                <FuseAuthorization>
                                    <ScreenLockApp>
                                        <FuseTheme>
                                            <FuseLayout />
                                        </FuseTheme>
                                        {/* <CookieConsent
                                                location="bottom"
                                                buttonText="Prosseguir"
                                                cookieName="AceiteCookies"
                                                style={{ background: "#E6E6E6", color: "#000", alignItems: "center", border: "solid 1px #CCC" }}
                                                buttonStyle={{ background: "#459DC2", color: "#FFF", fontSize: "16px", borderRadius: "4px" }}
                                                expires={150}
                                            >
                                                {"O HEXAPP utiliza cookies e outras tecnologias semelhantes para melhorar a sua experiência, de acordo com a nossa Política de Privacidade e, ao continuar navegando, você concorda com estas condições. "}
                                            </CookieConsent> */}
                                    </ScreenLockApp>
                                </FuseAuthorization>
                            </Router>
                        </Auth>
                    </Provider>
                </JssProvider>
            </AppContext.Provider>
        );
    }
};

export default App;
